import { useGetIdentity } from 'ra-core';
import { useQuery } from '@tanstack/react-query';
import { getUserProfile } from '@/dataProvider/dataProvider.ts';
import { Navigate } from 'react-router-dom';

export const CompleteProfilePage = () => {
  const { data: user, isLoading: isLoadingUser } = useGetIdentity();
  const { data: userProfile, isLoading: isLoadingUserProfile } = useQuery({
    queryKey: [user?.idpUserId],
    queryFn: async () => {
      return getUserProfile().then(profile =>
        profile ? profile : { message: 'no-profile' }
      );
    },
    enabled: !isLoadingUser,
  });

  if (isLoadingUserProfile) return null;
  if (isLoadingUser) return null;

  if (userProfile?.id) {
    // Profile already completed, navigate to main page
    return <Navigate to="/" />;
  }

  // const [firstName, lastName] = (user?.fullName || '').split(' ');
  //
  // return (
  //   <>
  //     <img alt="logo" src="https://storage.googleapis.com/public-goloot-production/goloot/goloot-logo-black.png" style={{ height: 32 }} />
  //
  //     <Typography variant="h5">{t('auth.message.profile_create')}</Typography>
  //
  //     <Box
  //       sx={{
  //         display: 'flex',
  //         justifyContent: 'center',
  //         width: '100%',
  //         maxWidth: 440,
  //       }}
  //     >
  //       <CompleteProfileForm firstName={firstName} lastName={lastName} />
  //     </Box>
  //   </>
  // );

  return (
    <>
      <img
        alt="logo"
        src="https://storage.googleapis.com/public-goloot-production/goloot/goloot-logo-black.png"
        style={{ height: 32 }}
      />

      <h5>{`Profile incomplete`}</h5>
    </>
  );
};
